import { render, staticRenderFns } from "./coderInpatientReviewPage.vue?vue&type=template&id=9d02ec08&scoped=true&"
import script from "./coderInpatientReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderInpatientReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientReviewPage.vue?vue&type=style&index=0&id=9d02ec08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d02ec08",
  null
  
)

export default component.exports